var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'contact'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "pt-16 sm-md:pt-32 contact--section effect--fade-slide-in"
  }, [_c('div', {
    staticClass: "section--container section--container-page"
  }, [!_vm.showError ? _c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("Thanks!")]), _vm._v(" "), _c('p', {
    staticClass: "text-xl sm-md:text-xl"
  }, [_vm._v("You're all set!")])]) : _vm._e(), _vm._v(" "), _vm.showError ? _c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("Sorry about that!")]), _vm._v(" "), _c('p', {
    staticClass: "text-xl sm-md:text-xl"
  }, [_vm._v("\n\t\t\t\t\tSomething went wrong on our end. \n\t\t\t\t")])]) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };